export var sanitizeInput = function (input) {
    var allowedTags = {
        'h1': ['#'],
        'h2': ['##'],
        'h3': ['###'],
        'h4': ['####'],
        'h5': ['#####'],
        'h6': ['######'],
        'p': [],
        'b': ['**', '***'],
        'strong': ['**', '***'],
        'i': ['*', '_'],
        'em': ['*', '_'],
        'u': [],
        'del': ['~~'],
        's': ['~~'],
        'ul': [],
        'ol': [],
        'li': ['-', '*', '1.', '2.', '3.'],
        'code': [],
        'pre': [],
        'a': ['href="URL"', 'download', 'href', '#id', 'target', '_self', '_blank', 'rel="noopener noreferrer"', 'title'],
        'span': [],
        'br': [],
        'hr': [],
        'small': [],
        'big': [],
        'font': ['color'],
        'button': [],
        'sup': [],
        'sub': [],
        'align': ['center'],
        'email': ['<email@example.com>'],
        'url': ['<https://example.com>']
    };
    var htmlTags = /<\/?([a-z][a-z0-9]*)[^>]*>/gi;
    return input.replace(htmlTags, function (match, tag) {
        if (allowedTags.hasOwnProperty(tag.toLowerCase())) {
            return match;
        }
        return '';
    });
};
export var convertMarkdownToHtml = function (input) {
    // Обработка заголовков (#text# → <h3>text</h3>)
    var output = input.replace(/#(.+?)#/g, '<h3>$1</h3>');
    // Обработка жирного текста (**text** → <strong>text</strong>)
    output = output.replace(/\*\*(.+?)\*\*/g, '<strong>$1</strong>');
    return output;
};
//# sourceMappingURL=sanitizeInput.js.mapexport var sanitizeInput = function (input) {
    var allowedTags = {
        'h1': ['#'],
        'h2': ['##'],
        'h3': ['###'],
        'h4': ['####'],
        'h5': ['#####'],
        'h6': ['######'],
        'p': [],
        'b': ['**', '***'],
        'strong': ['**', '***'],
        'i': ['*', '_'],
        'em': ['*', '_'],
        'u': [],
        'del': ['~~'],
        's': ['~~'],
        'ul': [],
        'ol': [],
        'li': ['-', '*', '1.', '2.', '3.'],
        'code': [],
        'pre': [],
        'a': ['href="URL"', 'download', 'href', '#id', 'target', '_self', '_blank', 'rel="noopener noreferrer"', 'title'],
        'span': [],
        'br': [],
        'hr': [],
        'small': [],
        'big': [],
        'font': ['color'],
        'button': [],
        'sup': [],
        'sub': [],
        'align': ['center'],
        'email': ['<email@example.com>'],
        'url': ['<https://example.com>']
    };
    var htmlTags = /<\/?([a-z][a-z0-9]*)[^>]*>/gi;
    return input.replace(htmlTags, function (match, tag) {
        if (allowedTags.hasOwnProperty(tag.toLowerCase())) {
            return match;
        }
        return '';
    });
};
export var convertMarkdownToHtml = function (input) {
    // Обработка заголовков (#text# → <h3>text</h3>)
    var output = input.replace(/#(.+?)#/g, '<h3>$1</h3>');
    // Обработка жирного текста (**text** → <strong>text</strong>)
    output = output.replace(/\*\*(.+?)\*\*/g, '<strong>$1</strong>');
    return output;
};
//# sourceMappingURL=sanitizeInput.js.map